import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@igooods/ui-kit';
import { WLabel } from 'constants/enums';
import { currentWLabel, selectByWL } from 'utils/wLabel';
import { Container, LinkStyled, LinkText } from './styled';
import { links } from '../consts';
import SubLinks from './SubLinks';
import ExternalLink from '../../ExternalLink';
import { URL } from '../../../constants/urlMaps';

const linkPaddingByWl = selectByWL({ [WLabel.Default]: 2, [WLabel.Globus]: 3 });

const FaqSidebar: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <Container>
      {links.map(({ url, title }) => (
        <Box key={url} py={linkPaddingByWl}>
          {title === 'Доставка для бизнеса' ? (
            <ExternalLink href={`${URL.business}?ref=site_info`}>
              <LinkText active={url === pathname}>{title}</LinkText>
            </ExternalLink>
          ) : (
            <LinkStyled to={url}>
              <LinkText active={url === pathname}>{title}</LinkText>
            </LinkStyled>
          )}
        </Box>
      ))}
      {currentWLabel === WLabel.Default && <SubLinks />}
    </Container>
  );
};

export default FaqSidebar;
